import { BookingState } from '@/components/Booking/models/BookingState';

export class BookingStates {

    static Undefined: BookingState = new BookingState(0, "Undefined");
    static Open: BookingState = new BookingState(10, "Open");
    static Ok: BookingState = new BookingState(200, "Ok");
    static Rejected: BookingState = new BookingState(300, "Rejected");
    static Cancelled: BookingState = new BookingState(400, "Cancelled");
    static Finished: BookingState = new BookingState(500, "Finished");

    static States = [
        BookingStates.Undefined,
        BookingStates.Open,
        BookingStates.Ok,
        BookingStates.Rejected,
        BookingStates.Cancelled,
        BookingStates.Finished,
    ]

    static SelectableStates = [
            BookingStates.Open,
            BookingStates.Ok,
            // BookingStates.Rejected,
            BookingStates.Cancelled,
            BookingStates.Finished,
    ]
    
    klass: object = BookingStates;
}

export default BookingState;
